import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';

interface DealerErrorNotificationProps {
  title: string;
  errorMessage?: string;

  contactDealerLink?: string;

  contactUsLabel?: string;
  handleShopAsGuest?: () => void;
  shopAsGuestLabel?: string;
}

export const DealerErrorNotification = ({
  title,
  errorMessage,
  contactDealerLink,
  contactUsLabel,
  handleShopAsGuest,
  shopAsGuestLabel
}: DealerErrorNotificationProps) => (
  <div>
    <CatInlineNotification
      variant="warning"
      data-testid="timeout-error"
      heading={title}
      className="text-start m-0 p-0"
    >
      <CatIconWarningTriangle slot="before" data-testid="error-icon" />
      {errorMessage}
      <div slot="after">
        <CatButton
          type="button"
          className="text-nowrap mt-md-2 pt-2 pt-md-0"
          href={contactDealerLink}
        >
          {contactUsLabel}
        </CatButton>
        <CatButton
          type="button"
          variant="ghost"
          className="ps-3"
          onClick={handleShopAsGuest}
        >
          {shopAsGuestLabel}
        </CatButton>
      </div>
    </CatInlineNotification>
  </div>
);
